import { render, staticRenderFns } from "./CompanySite.vue?vue&type=template&id=81c640cc&"
import script from "./CompanySite.vue?vue&type=script&lang=js&"
export * from "./CompanySite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports